/**
 * TipoOcorrencia
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {TipoOcorrenciaCollection} from '@/model/collection/TipoOcorrenciaCollection'

export class TipoOcorrencia extends Resource {
  idOcorrenciaPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  nome: string | null = null
  ativo: boolean = false
  ehDevolvida: boolean = false

  idOcorrenciaExterna: number | null = null

  get $id() {
    return this.idOcorrenciaPk
  }
  set $id(val) {
    this.idOcorrenciaPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of TipoOcorrencia
   */
  async getTipoOcorrencia(id: number) {
    return await Request.get(`/admin/tipo-ocorrencia/${id}`)
      .name('getTipoOcorrencia')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of TipoOcorrencia
   */
  async removeTipoOcorrencia() {
    return await Request.delete(`/admin/tipo-ocorrencia/${this.$id}`)
      .name('removeTipoOcorrencia')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TipoOcorrencia
   */
  static async listTipoOcorrencia(params: any) {
    return await Request.get(`/admin/tipo-ocorrencia`, {params})
      .name('listTipoOcorrencia')
      .as(TipoOcorrenciaCollection)
      .getData()
  }

  /**
   * Persists a new instance of TipoOcorrencia. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistTipoOcorrencia() {
    return await Request.post(`/admin/tipo-ocorrencia`, this)
      .name('persistTipoOcorrencia')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TipoOcorrencia to use it in a CSV file
   */
  static async listCsvTipoOcorrencia(params: any) {
    return await Request.get(`/admin/tipo-ocorrencia/csv`, {params})
      .name('listCsvTipoOcorrencia')
      .as(TipoOcorrenciaCollection)
      .getData()
  }
}
